import { QuotationsInfoResponse } from 'interfaces/quotationsInfo'
import { CardInfos } from '../card-infos'
import '../../index.scss'

interface ProductsCardsGridProps {
    quotationsInfo: QuotationsInfoResponse | null
}

export const ProductsCardsGrid = ({
    quotationsInfo,
}: ProductsCardsGridProps) => {
    function calculatePercentageWon(
        won?: number,
        answeredTotal?: number
    ): number {
        if (!answeredTotal || !won) return 0
        return (won / answeredTotal) * 100
    }

    return (
        <div className="cardsContent">
            <div className="cards">
                <CardInfos
                    title={'Recebidas'}
                    total={quotationsInfo?.productReceived.period.total ?? 0}
                    metrics={[
                        {
                            percentage:
                                quotationsInfo?.productReceived.period
                                    .percent ?? 0,
                            description: 'sobre o mês anterior',
                            sign: quotationsInfo?.productReceived.period
                                .sign as '+' | '-' | '=',
                        },
                        {
                            percentage:
                                quotationsInfo?.productReceived.previous_year
                                    .percent ?? 0,
                            description: 'sobre o ano anterior',
                            sign: quotationsInfo?.productReceived.previous_year
                                .sign as '+' | '-' | '=',
                        },
                    ]}
                />
            </div>
            <div className="cards">
                <CardInfos
                    title={'Não Vencidas'}
                    total={quotationsInfo?.productLoser?.period.total ?? 0}
                    metrics={[
                        {
                            percentage:
                                quotationsInfo?.productLoser?.period.percent ??
                                0,
                            description: 'sobre o mês anterior',
                            sign: quotationsInfo?.productLoser?.period.sign as
                                | '+'
                                | '-'
                                | '=',
                        },
                        {
                            percentage:
                                quotationsInfo?.productLoser?.previous_year
                                    .percent ?? 0,
                            description: 'sobre o ano anterior',
                            sign: quotationsInfo?.productLoser?.previous_year
                                .sign as '+' | '-' | '=',
                        },
                    ]}
                />
            </div>
            <div className="cards">
                <CardInfos
                    title={'Não Digitadas'}
                    total={quotationsInfo?.productNotTyped?.period.total ?? 0}
                    metrics={[
                        {
                            percentage:
                                quotationsInfo?.productNotTyped?.period
                                    .percent ?? 0,
                            description: 'sobre o mês anterior',
                            sign: quotationsInfo?.productNotTyped?.period
                                .sign as '+' | '-' | '=',
                        },
                        {
                            percentage:
                                quotationsInfo?.productNotTyped.previous_year
                                    .percent ?? 0,
                            description: 'sobre o ano anterior',
                            sign: quotationsInfo?.productNotTyped?.previous_year
                                .sign as '+' | '-' | '=',
                        },
                    ]}
                />
            </div>
            <div className="cards">
                <CardInfos
                    title={'Respondidas'}
                    total={quotationsInfo?.productAnswered.period.total ?? 0}
                    metrics={[
                        {
                            percentage:
                                quotationsInfo?.productAnswered.period
                                    .percent ?? 0,
                            description: 'sobre o mês anterior',
                            sign: quotationsInfo?.productAnswered.period
                                .sign as '+' | '-' | '=',
                        },
                        {
                            percentage:
                                quotationsInfo?.productAnswered.previous_year
                                    .percent ?? 0,
                            description: 'sobre o ano anterior',
                            sign: quotationsInfo?.productAnswered.previous_year
                                .sign as '+' | '-' | '=',
                        },
                    ]}
                />
            </div>
            <div className="cards">
                <CardInfos
                    title={'Ganhas'}
                    total={quotationsInfo?.productVictory.period.won ?? 0}
                    percentage={
                        quotationsInfo?.productVictory.period.percent ?? 0
                    }
                    percentageWon={calculatePercentageWon(
                        quotationsInfo?.productVictory?.period?.won,
                        quotationsInfo?.productAnswered.period.total
                    )}
                    metrics={[
                        {
                            percentage:
                                quotationsInfo?.productVictory.previous_month
                                    .percent ?? 0,
                            description: 'sobre o mês anterior',
                            sign: quotationsInfo?.productVictory.previous_month
                                .sign as '+' | '-' | '=',
                        },
                        {
                            percentage:
                                quotationsInfo?.productVictory.previous_year
                                    .percent ?? 0,
                            description: 'sobre o ano anterior',
                            sign: quotationsInfo?.productVictory.previous_year
                                .sign as '+' | '-' | '=',
                        },
                    ]}
                />
            </div>
        </div>
    )
}
